
import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup,FormControl, Validators,ReactiveFormsModule  } from '@angular/forms';
//import Swal from "sweetalert2";
import { Router,ActivatedRoute } from "@angular/router";
//import { Observable } from "rxjs/Observable";
import { EmpresaService } from "../service/empresa/empresa.service";
import { DocumentoService } from "../service/documento/documento.service";
import {SecurityService} from "../service/security/security.service"
import {MatStepperModule,MatStepper} from '@angular/material/stepper'
import { Persona } from '../models/Persona';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { DatePipe } from "@angular/common";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-stepper',
  templateUrl: './sorteo.component.html',
  styles: [`
    .mat-list-icon {
      color: rgba(0, 0, 0, 0.54);
    }`],
  providers:[DatePipe,Persona]
})
export class SorteoComponent implements OnInit {
  id_empresa=environment.ID_EMPRESA;
  isLinear = true;
  pasoUno: FormGroup;
  pasoDos: FormGroup;
  pasoTres: FormGroup;
  formSendProveedor: FormGroup;
  loading: boolean = false;
  error: boolean = false;
  mensajeError: any = "Campo requerido.";
  proveedor: any = {};
  persona: any = {};
  mensajeErrorRuc: string;
  mensajeErrorDni: string;
  contactosArray:any = [];
  editarProveedor: boolean = true;
  editarContacto: boolean = true;
  flag:boolean = true;
  formularioContacto : FormGroup;
  formularioSecurity : FormGroup;
  DepaCombo: any;
  ProvCombo: any= [];
  DistCombo: any= [];
  code: any;
  IGV_Exonerado: any = "N";
  Scoring_Puntaje: any = "0";
  @ViewChild('stepper', {static: false}) stepper: MatStepper;

  constructor(
    private negociabesService: DocumentoService,
    private empresasService: EmpresaService,
    private securityService: SecurityService,
    private _formBuilder: FormBuilder,
    private router: Router,
    private datePipe: DatePipe,
    private activateRoute :ActivatedRoute) {
  }

  ngOnInit() {

    /*this.pasoUno = this._formBuilder.group({
      DNI: ['', (Validators.required,Validators.minLength(8),Validators.pattern("[0-9]{8}$"))] ,
      RUC: ['', (Validators.required,Validators.minLength(11),Validators.pattern("[0-9]{11}$"))],

    });*/
    this.pasoUno = new FormGroup({
      DNI: new FormControl('', [Validators.required,Validators.minLength(8),Validators.pattern("[0-9]{8}$")]),
      RUC: new FormControl('',[] ),
    });

    this.pasoDos = this._formBuilder.group({
      RUC: [{ value: "", disabled: true }, (Validators.required,Validators.minLength(8),Validators.pattern("[0-9]{8}$"))],
      razonSocial: ['', Validators.required] ,
      nombreComercial: ['', (Validators.required)] ,
      direccionFiscal: ['', (Validators.required)] ,
      departamento: ['', Validators.required] ,
      provincia: ['', Validators.required] ,
      distrito: ['', Validators.required] ,
      idProveedor: [''] ,
      Usuario: ['MKT', Validators.required]

    });
    this.pasoTres = this._formBuilder.group({
      idContacto: [''],
      DNI: [{ value: "", disabled: true }, Validators.required],
      apellidoPaterno: [{ value: "", disabled: true }, Validators.required],
      apellidoMaterno: [{ value: "", disabled: true }, Validators.required],
      primerNombre: [{ value: "", disabled: true }, Validators.required],
      segundoNombre: [{ value: "", disabled: true }],
      correo: ['', (Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'))],
      celular: ['', (Validators.required,Validators.minLength(5), Validators.pattern("[0-9]+"))],
      observaciones:[''],
      flag:['S'],
    });

    this.empresasService.obtenerDepartamento().subscribe( resp => {
      this.DepaCombo= resp;
    },err => {
      console.log('err', err)
    });
  }
  cargarProvincia(idDepa: string){
    console.log("pra",idDepa);
    this.loading = true;
    this.empresasService.obtenerProvincia(idDepa).subscribe( resp => {
      console.log("bien",resp);
      this.ProvCombo= resp;
      this.loading = false;
    },err => {
      this.loading = false;
      console.log('err', err)
    });
  }
  cargarDistrito(idProv: string){
    this.loading = true;
    this.empresasService.obtenerDistrito(idProv).subscribe( resp => {
      this.DistCombo= resp;
      this.loading = false;
    },err => {
      this.loading = false;
      console.log('err', err)
    });
  }
  toggleFlag(){
    if(this.pasoTres.get('flag').value == 'S'){
      this.flag = true;
    }else{
      this.flag = false;
    }
  }
  nextPaso1(){
    if (this.pasoUno.invalid) {
      this.mensajeErrorDni = "Campo requerido.";
      this.mensajeErrorRuc = "Campo requerido.";
      return;
    }
    this.validarProveedor(this.pasoUno.get("RUC").value,this.pasoUno.get("DNI").value);
  }
  nextPaso2(){
    if (this.pasoDos.invalid) {
      return;
    }
    
    this.stepper.next();
    //this.guardarCambiosProveedor();
  }
  nextPaso3(){
    if (this.pasoTres.invalid) {
      return;
    }
    this.guardarCambiosContacto();
  }
  obtenerPersona(dni: any){
    this.loading=true;
    let bodyObtenerPersona = {
      'Tipo_Documento_Identidad': '',
      'NroDoc' : ''
    }
    bodyObtenerPersona.NroDoc = dni;
    bodyObtenerPersona.Tipo_Documento_Identidad = 'D';
    this.empresasService.obtenerPersonaRiesgo(bodyObtenerPersona)
          .subscribe( res => {
              this.persona = res as Persona;
              console.log(this.persona);
              if(this.persona["message"]){
                this.error = true;
                this.loading=false;
                this.pasoUno.get("DNI").setValue("");
                this.mensajeErrorDni = "DNI incorrecto.";
              }else{
                this.pasoTres.controls["DNI"].setValue(this.persona.Documento);
                this.pasoTres.controls["apellidoPaterno"].setValue(this.persona.ApellidoPaterno);
                this.pasoTres.controls["apellidoMaterno"].setValue(this.persona.ApellidoMaterno);
                this.pasoTres.controls["primerNombre"].setValue(this.persona.PrimerNombre);
                this.pasoTres.controls["segundoNombre"].setValue(this.persona.SegundoNombre);
                //this.pasoTres.controls["correo"].setValue(this.persona.Documento);
                //this.pasoTres.controls["celular"].setValue(this.persona.Documento);
                this.loading=false;
                this.stepper.next();
                this.editarContacto = true;
              }
          },error => {
            let message;
            if(error.status == 0){
              message = "Servicio caído, contactarse con el área de soporte.";
            }else{
              message = "Ocurrió un error. Por favor contactarse con el área de soporte.";
            }
            this.error=true;
            this.mensajeError = message;
            this.loading = false;
          })

  }
  validarProveedor(idProveedor: string, DNI: String) {
    console.log('hola',idProveedor,DNI)
    this.proveedor = {};
    this.resetFormContacto();
    this.resetFormEmpresa();

    this.loading = true;
    this.negociabesService.validarEmpresaExistente(idProveedor).subscribe(
      data => {
        if (data == null) {
          this.error = true;
          this.mensajeError = "Proveedor no encontrado.";
          this.loading = false;
          this.mensajeErrorRuc = "Ruc no permitido.";
          this.pasoUno.get("RUC").setValue("");
          this.editarProveedor = false;
          this.editarContacto = false;
          //this.pasoDos.controls["RUC"].setValue(idProveedor);
          //this.obtenerPersona(DNI);
          return;
        } else {
          this.proveedor = data;
          console.log("data",this.proveedor);
          (this.error = false),
          //this.cargarProvincia(this.proveedor.Departamento);
          //this.cargarDistrito(this.proveedor.Provincia);
          this.pasoDos.controls["RUC"].setValue(this.proveedor.Num_Doc_Identificacion);
          this.pasoDos.controls["idProveedor"].setValue(this.proveedor.idEmpresa);
          this.Scoring_Puntaje = this.proveedor.Scoring_Puntaje;
          this.IGV_Exonerado = this.proveedor.IGV_Exonerado;
          /*this.pasoDos.controls["razonSocial"].setValue(this.proveedor.Razon_Social);
            this.pasoDos.controls["nombreComercial"].setValue(this.proveedor.Nombre_Comercial);
            this.pasoDos.controls["direccionFiscal"].setValue(this.proveedor.Direccion_Fiscal);
            this.pasoDos.controls["departamento"].setValue(this.proveedor.Departamento);
            this.pasoDos.controls["provincia"].setValue(this.proveedor.Provincia);
            this.pasoDos.controls["distrito"].setValue(this.proveedor.Distrito);
            */
                //let datas : any;
                this.empresasService.obtenerContactosEmpresa1(this.proveedor.idEmpresa)
                .subscribe(res => {
                  console.log('resPersona',res)
                    this.contactosArray = res;
                    this.contactosArray = this.contactosArray.filter(
                      state => state.Nro_Documento_Identidad.toLowerCase().indexOf(DNI) === 0
                    );
                    console.log('arrayPersona',this.contactosArray)
                    if(this.contactosArray.length === 0){
                      this.obtenerPersona(DNI);
                      this.editarContacto = false;
                    }else{
                      this.pasoTres.controls["idContacto"].setValue(this.contactosArray[0].idContacto);
                      this.pasoTres.controls["DNI"].setValue(this.contactosArray[0].Nro_Documento_Identidad);
                      this.obtenerPersona(DNI);

                      /*this.pasoTres.controls["apellidoPaterno"].setValue(this.contactosArray[0].Apellido_Paterno);
                      this.pasoTres.controls["apellidoMaterno"].setValue(this.contactosArray[0].Apellido_Materno);
                      this.pasoTres.controls["primerNombre"].setValue(this.contactosArray[0].Nombre1);
                      this.pasoTres.controls["segundoNombre"].setValue(this.contactosArray[0].Nombre2);
                      this.pasoTres.controls["correo"].setValue(this.contactosArray[0].Correo);
                      this.pasoTres.controls["celular"].setValue(this.contactosArray[0].NroMovil_Laboral); */
                      this.loading = false;
                      this.stepper.next();
                      this.editarContacto = true;
                    }
                });
        }
      },
      error => {
        let message;
        if(error.status == 0){
          message = "Servicio caído, contactarse con el área de soporte.";
        }else{
          message = "Ocurrió un error. Por favor contactarse con el área de soporte.";
        }
        this.error=true;
        this.mensajeError = message;
        this.loading = false;
      }
    );
  }
  resetFormContacto(){
    this.pasoTres.controls["DNI"].setValue('');
    this.pasoTres.controls["apellidoPaterno"].setValue('');
    this.pasoTres.controls["apellidoMaterno"].setValue('');
    this.pasoTres.controls["primerNombre"].setValue('');
    this.pasoTres.controls["segundoNombre"].setValue('');
    this.pasoTres.controls["correo"].setValue('');
    this.pasoTres.controls["celular"].setValue('');
  }
  resetFormEmpresa(){
    this.pasoDos.get("RUC").setValue("");
    this.pasoDos.get("razonSocial").setValue("");
    this.pasoDos.get("nombreComercial").setValue("");
    this.pasoDos.get("direccionFiscal").setValue("");
    this.pasoDos.get("departamento").setValue("");
    this.pasoDos.get("provincia").setValue("");
    this.pasoDos.get("distrito").setValue("");
  }
  cargarFormSend(){
    this.formSendProveedor = new FormGroup({
      TipoEmpresa: new FormControl('P', [Validators.required]),
      Razon_Social: new FormControl({ value: this.pasoDos.get('razonSocial').value, disabled: false }, [Validators.required]),
      Num_Doc_Identificacion: new FormControl({ value: this.pasoDos.get('RUC').value, disabled: false }, [Validators.required, Validators.pattern("[0-9]{11}$")]),
      Nombre_Comercial: new FormControl(this.pasoDos.get('nombreComercial').value, [Validators.required]),
      Tipo_Doc_Identificacion: new FormControl(33, [Validators.required]),
      Direccion_Fiscal: new FormControl({ value: this.pasoDos.get('direccionFiscal').value, disabled: false }, [Validators.required]),
      Departamento: new FormControl({ value: this.pasoDos.get('departamento').value, disabled: false }, [Validators.required]),
      Provincia: new FormControl({ value:this.pasoDos.get('provincia').value, disabled: false }, [Validators.required]),
      Distrito: new FormControl({ value: this.pasoDos.get('distrito').value, disabled: false }, [Validators.required]),
      //Pais: new FormControl('', [Validators.required]),
      //UBIGEO: new FormControl('', ),
      Modificaion_Fecha: new FormControl(this.datePipe.transform(Date(),"yyyy-MM-dd"), []),
      Modificaion_Canal: new FormControl('W', []),
      Modificaion_Usuario: new FormControl('MKT', []),
      Usuario: new FormControl('MKT', []),
      UBIGEO:  new FormControl(this.pasoDos.get('distrito').value, []),
      Pais : new FormControl("Peru", []),
      Scoring_Puntaje : new FormControl(this.Scoring_Puntaje, []),
      Scoring_Fecha_Consulta : new FormControl(this.datePipe.transform(Date(),"yyyy-MM-dd"), []),
      IGV_Exonerado:  new FormControl(this.IGV_Exonerado, []),
    });
  }
  cargarFormSendContacto(){
    let name =  this.pasoTres.controls['apellidoPaterno'].value + ' ' +   this.pasoTres.controls['apellidoMaterno'].value + ', ' +   this.pasoTres.controls['primerNombre'].value + ' ' +  this.pasoTres.controls['segundoNombre'].value;
    let obser = this.pasoTres.get('flag').value+' - '+this.pasoTres.get('observaciones').value;
    this.formularioContacto = new FormGroup({
      "idEmpresas":new FormControl(this.pasoDos.get('idProveedor').value,  Validators.required),
      "Tipo_Documento_Identidad": new FormControl(31,  Validators.required),
      "Nombre_de_Contacto": new FormControl(name,  Validators.required),
      "Nro_Documento_Identidad": new FormControl(this.pasoTres.get('DNI').value,  Validators.required),
      "Apellido_Paterno": new FormControl(this.pasoTres.get('apellidoPaterno').value,  Validators.required),
      "Apellido_Materno":new FormControl(this.pasoTres.get('apellidoMaterno').value,  Validators.required),
      "Nombre1":new FormControl(this.pasoTres.get('primerNombre').value,  Validators.required),
      "Nombre2": new FormControl(this.pasoTres.get('segundoNombre').value,  Validators.required),
      "NroMovil_Laboral": new FormControl(this.pasoTres.get('celular').value,  Validators.required),
      //"NroFijo_Laboral":new FormControl('',  Validators.required),
      //"Anexo":new FormControl(''),
      "Correo": new FormControl(this.pasoTres.get('correo').value,  Validators.required),
      "Usuario": new FormControl('MKT'),
      "Tipo_de_Contacto":new FormControl(56),
      "Rol_del_Contacto":new FormControl([45]),
      "Condicion":new FormControl(3),
      "Observaciones": new FormControl(obser),
   });
  }
  cargarFormSendUsuarioSecurity(){
    let name =  this.pasoTres.controls['primerNombre'].value + ' ' +  this.pasoTres.controls['segundoNombre'].value+' '+this.pasoTres.controls['apellidoPaterno'].value + ' ' +   this.pasoTres.controls['apellidoMaterno'].value;
    this.code = (Math.floor(Math.random()*100*1000))+500000;
    this.formularioSecurity = new FormGroup({
      "Usuario":new FormControl(this.pasoTres.get('DNI').value,  Validators.required),
      "Nombre": new FormControl(name,  Validators.required),
      "Password": new FormControl(123456,  Validators.required),
      "Email": new FormControl(this.pasoTres.get('correo').value,  Validators.required),
      "Telefono": new FormControl(this.pasoTres.get('celular').value,  Validators.required),
      //"estado":new FormControl("3",  Validators.required),
      //"validate":new FormControl("true"),
      "id_empresa":new FormControl(this.id_empresa),
      "NombreProyecto":new FormControl("Extranet"),
      "Canal": new FormControl("W", [Validators.required]),
      "Host": new FormControl("0", [Validators.required]),
      "IP": new FormControl("0", [Validators.required])
   });
  }
  guardarCambiosProveedor(){
    if(this.pasoDos.invalid) {
      return;
    }
    this.loading = true;
    this.cargarFormSend();

    console.log("PASO-DOS",this.formSendProveedor.getRawValue());
        if(this.editarProveedor){
          this.empresasService.actualizarEmpresa(this.pasoDos.get('idProveedor').value, this.formSendProveedor.getRawValue())
          .subscribe( resp => {
            console.log("rpta:editar",resp);
            this.loading=false;
            this.stepper.next();
          },err => {
            console.log('err', err)
          })
        }else{
          this.empresasService.registrarEmpresa(this.formSendProveedor.getRawValue())
          .subscribe( resp => {
            console.log("rpta:crear",resp);
          },err => {
            console.log('err', err)
          })
        }
  }
  sendNotificacion(){
    this.cargarFormSendUsuarioSecurity();
    console.log('data',this.formularioSecurity.getRawValue());
    this.securityService.createUsuario(this.formularioSecurity.getRawValue()).subscribe(res => {

      this.loading=false;
      this.router.navigate(['/thanks']);
    })

  }
  guardarCambiosContacto(){
    this.loading=true;
    this.cargarFormSendContacto();
    if(this.editarContacto){
      console.log('data',this.formularioContacto.getRawValue());
      //console.log('data',this.pasoTres.get('idContacto').value);
      //return
      this.empresasService.actualizarContacto(this.pasoTres.get('idContacto').value, this.formularioContacto.getRawValue())
      .subscribe(res => {
          this.sendNotificacion();
      })
    }else{
      this.empresasService.agregarContacto(this.formularioContacto.getRawValue())
      .subscribe(res => {
          this.sendNotificacion();
      },err => {
        this.loading = false;
        let mensaje;
        if(err.status == 0){
          mensaje = "Problema con el servidor, por favor contactarse con soporte.";
        }else if(err.status == 422){
          mensaje= "Datos incoorectos.";
        }else{
          mensaje= err.message;
        }
      })
    }
  }

}
